import { WebPlugin } from '@capacitor/core';
export class NativePickerWeb extends WebPlugin {
    showPicker() {
        return new Promise((r, j) => {
            const selectedIndex = parseInt(prompt('Enter amount') || '0');
            if (isNaN(selectedIndex))
                j('Wrong number');
            r({ selectedIndex });
        });
    }
}
//# sourceMappingURL=web.js.map